module.exports = __webpack_public_path__ + "static/media/aetna.cf4d492d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/images/partner/logos/aetna.svg
// module id = 28
// module chunks = 0